import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

/*
 * The live text2pay link for a booking that is still held. The backend answers with a
 * null link once the hold is gone or paid, so a stale link is never handed over.
 */
const responseSchema = yup.object({
  paymentLink: yup.string().nullable(),
  expiresAt: yup.number().nullable(),
});

const composeResponse = (response) => {
  const data = response?.data?.data;

  return {
    paymentLink: data?.payment_link || null,
    expiresAt: data?.expires_at || null,
  };
};

export function useAppointmentPaymentLinkQuery(
  { appointmentId },
  options = {},
) {
  return useQuery(
    [QUERY_KEYS.appointments.paymentLink, appointmentId],
    async () => {
      const res = await http.get(
        HTTP_ENDPOINTS.appointments.getPaymentLink(appointmentId),
      );
      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    options,
  );
}
